export default __webpack_public_path__ + "static/PDP_1_Hover-3311e7624a734c08ff59836fe8242552.png";